// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Data\AuthorizedDataController.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Domain, DomainData, DomainOptions } from 'data/models/Domain';
import { UserSummary, UserSummaryData, UserSummaryOptions } from 'data/models/UserSummary';

// AuthorizedDataData is the class that AuthorizedData serializes to/from
export interface AuthorizedDataData {
    Id : number;
	
    Domain : DomainData | null;
    UserSummary : UserSummaryData | null;
	
}

// AuthorizedDataOptions is the class which may be passed to the AuthorizedData constructor to define optional initial data values
export interface AuthorizedDataOptions {
    Id : number;
	
    Domain? : DomainOptions | null;
    UserSummary? : UserSummaryOptions | null;
	
}

export class AuthorizedData {
    public Id : DataSignal<number>;
	
    public Domain : DataSignal<Domain | null>;
    public UserSummary : DataSignal<UserSummary | null>;
	

    constructor();
    constructor(data : AuthorizedDataOptions);
    constructor(data: AuthorizedDataOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Domain = S.value<Domain | null>(null);
        this.UserSummary = S.value<UserSummary | null>(null);
	    
    }

    static key(obj : AuthorizedData) {
        return obj.Id();
    }
    
    static dataKey(obj : AuthorizedDataOptions) {
        return obj.Id;
    }

    static update(obj : AuthorizedData, data : AuthorizedDataOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/AuthorizedData.ts